import { render } from "./ListAdd.vue?vue&type=template&id=2e796406&ts=true"
import script from "./ListAdd.vue?vue&type=script&lang=ts"
export * from "./ListAdd.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__